import DeleteIcon from "../../images/icon_delete.svg";
import PDFIcon from "../../images/icon_pdf.svg";
import UploadIcon from "../../images/icon_upload_file.svg";
import { FILE_FORMATS } from "../../utils/constants";
import FileDropArea from "../FileDropArea/FileDropArea";
import {
  DashedRow,
  FileInfo,
  FilesList,
  RowContainer,
} from "./FileUploadInputStyles";

function FileUploadInput(props) {
  const { onValueChange, value, maxFiles, formats, width, height, disabled } =
    props;
  const appendFiles = (newFiles) => {
    onValueChange([...value, ...newFiles].slice(0, maxFiles || 1));
  };

  const removeFile = (deleteIdx) => {
    onValueChange(value.filter((_, idx) => idx !== deleteIdx));
  };

  const formatSize = (bytes) => {
    if (bytes < 1000000) return Math.max(Math.round(bytes / 1000), 1) + " KB";
    if (bytes < 1000000000)
      return Math.round((bytes / (1000 * 1000)) * 10) / 10 + " MB";
    return "More than 1GB";
  };

  const extensions = formats.flat().map((format) => {
    return typeof format === "object" ? format.extension : format;
  });
  const flatFormats = extensions.join(" ");

  const accepts = formats.flat().map((format) => {
    return typeof format === "object" ? format.accept : format;
  });

  return (
    <>
      <FilesList>
        {value.map((file, idx) => {
          return (
            <FileInfo key={idx}>
              <div>
                <img src={PDFIcon} alt="PDFIcon" />
                <p>{file.name}</p>
                <p className="size">{formatSize(file.size)}</p>
              </div>
              <img
                className="delete-icon"
                src={DeleteIcon}
                alt="DeleteIcon"
                style={{ cursor: `${disabled ? "not-allowed" : "pointer"}` }}
                onClick={() => {
                  if (!disabled) {
                    removeFile(idx);
                  }
                }}
              />
            </FileInfo>
          );
        })}
      </FilesList>
      {value.length < maxFiles ? (
        <RowContainer width={width} height={height}>
          <FileDropArea
            onDrop={appendFiles}
            formats={accepts || [FILE_FORMATS.PDF, FILE_FORMATS.IMAGE]}
            validExtensions={extensions}
            disabled={disabled}
          >
            <DashedRow>
              <img src={UploadIcon} alt="UploadIcon" />
              <div>{`Arrastra el documento para subirlo, o haz click para seleccionar
              uno.`}</div>
              <div>{`Extensiones válidas: ${flatFormats}`}</div>
            </DashedRow>
          </FileDropArea>
        </RowContainer>
      ) : null}
    </>
  );
}

export default FileUploadInput;
